import { motion } from "framer-motion";

export function Sticker({ children, className = "", rotate = -6, color = "white", textColor = "#282829" }) {
  return (
    <motion.div
      initial={{ scale: 0, rotate: 0 }}
      whileInView={{ scale: 1, rotate }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ type: "spring", stiffness: 220, damping: 12 }}
      className={`sticker ${className}`}
      style={{ background: color, color: textColor }}
    >
      {children}
    </motion.div>
  );
}

export function FloatingObject({ src, size = 120, x = "0%", y = "0%", rotate = 0, delay = 0, className = "" }) {
  return (
    <motion.img
      src={src}
      alt=""
      className={`absolute pointer-events-none select-none ${className}`}
      style={{ left: x, top: y, width: size, height: size, "--r": `${rotate}deg` }}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay, duration: 0.7, ease: "easeOut" }}
    />
  );
}
